// extracted by mini-css-extract-plugin
export default {"main":"Home_main__Elrlt","headline":"Home_headline__zSKhj"};